import { auth } from "@/config/firebase";
import { log } from "@/utils/logger";
import { GoogleAuthProvider, signInWithRedirect } from "firebase/auth";

const useGoogleSign = () => {
    const onGoogleSign = async () => {
        try {
            const provider = new GoogleAuthProvider();
            await signInWithRedirect(auth, provider);
        } catch (e) {
            log.error(e, "onGoogleSign");
        }
    };

    return onGoogleSign;
};

export default useGoogleSign;
